import { Box } from '@chakra-ui/react';
import React from 'react';

import CreditAgreements from 'capitalProvider/domains/credit-agreements/ui/CreditAgreements';
import { CreditAgreementsViewTemplate } from 'capitalProvider/domains/credit-agreements/ui/CreditAgreementsViewTemplate';
import { dashboardRoutePadding } from 'packages/common-frontend/constants';

export const CreditAgreementsRoute = () => {
  return (
    <Box padding={dashboardRoutePadding}>
      <CreditAgreementsViewTemplate disableSelectors={false}>
        <CreditAgreements />
      </CreditAgreementsViewTemplate>
    </Box>
  );
};
